export default "__VITE_ASSET__De8yC4cq__"